<template>
  <div>
    <div v-loading="loading">
      <el-form
        ref="form"
        :model="formData"
        label-width="120px"
        label-position="top"
        size="mini"
        :rules="rules"
        :disabled="disabled"
      >
        <div class="d-flex">
          <div class="pr-1 image_div">
            <el-image
              :src="defaultImageUrl"
              :preview-src-list="[defaultImageUrl]"
              style="width:135px; height:135px"
            >
              <div slot="error" class="image-slot">
                <img
                  src="/image/static/img/nopic.jpg"
                  style="width:135px; height:135px"
                />
              </div>
            </el-image>
          </div>
          <div style="flex:1">
            <div class="el-descriptions">
              <div class="el-descriptions__body descriptions__body_header">
                <div
                  class="el-descriptions__table is-bordered el-descriptions--small"
                >
                  <div class="el-descriptions-row">
                    <div
                      class="el-descriptions-item__cell el-descriptions-item__label is-bordered-label bg-white"
                      style="padding:6px"
                    >
                      <div class="sku_main">
                        <div>
                          <span v-if="formData.goodsName">
                            {{ formData.goodsName }}
                          </span>
                        </div>
                        <div>
                          <span v-if="formData.goodsNameEn">
                            {{ formData.goodsNameEn }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-descriptions
              border
              size="small"
              class="bottom-desc"
              :column="2"
            >
              <el-descriptions-item
                :label="$l('form_label_hxSkuNo') || 'SKU款号'"
                :labelStyle="{ width: '120px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.amzSkuNo }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_ncNo') || 'NC编号'"
                :labelStyle="{ width: '120px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.ncNo }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_brandName') || '品牌'"
                :labelStyle="{ width: '120px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.brandName }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_collectionName') || '系列'"
                :labelStyle="{ width: '120px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.collectionName }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_pattern') || '花型'"
                :labelStyle="{ width: '120px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.goodsPattern }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_categoryFullName') || '品类'"
                :labelStyle="{ width: '120px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.categoryFullName }}
              </el-descriptions-item>
            </el-descriptions>

            <el-descriptions
              border
              size="small"
              class="bottom-desc"
              :column="2"
            >
              <el-descriptions-item
                :label="$l('form_label_goodsSize') || '尺寸'"
                :labelStyle="{ width: '103px', height: '32px' }"
                :contentStyle="{ width: '305px', height: '32px' }"
              >
                {{ formData.goodsSize }}
              </el-descriptions-item>

              <el-descriptions-item
                :label="$l('form_label_inCtnQty_1') || '入数'"
                :labelStyle="{ width: '100px', height: '32px' }"
                :contentStyle="{ width: '100px', height: '32px' }"
              >
                {{ formData.inCtnQty }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
        <div class="d-flex pt_6 mt-2 side_frame_div">
          <div class="side-frame"></div>
          <div>
            <span style="font-size: 14px; color: #6C6C6C ">
              {{ $l('form_label_planning_reporting') || '企划填报' }}
            </span>
          </div>
        </div>

        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_qty_1') || '订单产品数量'"
              prop="qty"
            >
              <el-input-number
                v-if="planningDisabled"
                v-model="formData.qty"
                style="width: 100%"
                controls-position="right"
                :min="0"
                :step="1"
                :controls="false"
                :precision="0"
              />

              <el-input v-else v-model="formData.qty" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_ctnQty_1') || '订单产品箱数'"
              prop="ctnQty"
            >
              <el-input v-model="ctnQty" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_sampleQty_1') || '订单样品数量'"
            >
              <el-input v-model="formData.sampleQty" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_subQty_1') || '订单产品总数量'"
            >
              <el-input v-model="subQty" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$l('form_label_firstSaleDay_1') || '首批订单上架日期'"
              prop="firstSaleDay"
            >
              <el-date-picker
                v-model="formData.firstSaleDay"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
                :readonly="!planningDisabled"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$l('form_label_cargoReadyDay') || '工厂货好日期'"
              prop="cargoReadyDay"
            >
              <el-date-picker
                v-model="formData.cargoReadyDay"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
                :readonly="!planningDisabled"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_designRemark') || '企划备注'">
              <el-input
                v-model="formData.designRemark"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                type="textarea"
                :rows="2"
                maxlength="200"
                show-word-limit
                :readonly="!planningDisabled"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <ItemTable
            ref="itemTable"
            :disabled="disabled"
            :planningDisabled="planningDisabled"
            :amzFirstDemandDetailCode="amzFirstDemandDetailCode"
            @updateDemandQty="(e) => (formData.sampleQty = e)"
          />
        </el-row>

        <div class="d-flex pt_6 mt-2 side_frame_div">
          <div class="side-frame-success"></div>
          <div>
            <span style="font-size: 14px; color: #6C6C6C ;line-height: 25px; ">
              {{ $l('form_label_operations_reporting') || '运营填报' }}
            </span>
          </div>
        </div>

        <el-row :gutter="10" type="flex" justify="space-between">
          <el-col>
            <el-form-item
              :label="$l('form_label_firstQty_1') || '首批产品上架数量'"
              prop="firstQty"
            >
              <el-input-number
                v-if="!planningDisabled"
                v-model="formData.firstQty"
                style="width: 100%"
                controls-position="right"
                :min="0"
                :step="1"
                :controls="false"
                :precision="0"
              />
              <el-input v-else v-model="formData.firstQty" readonly />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              :label="$l('form_label_firstBoxs') || '首批产品上架箱数'"
              prop="firstBox"
            >
              <el-input v-model="firstBox" readonly />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              :label="$l('form_label_shipmentDate') || '订舱开始日期'"
              prop="shipmentDate"
            >
              <el-date-picker
                v-model="formData.shipmentDate"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
                :readonly="planningDisabled"
                :picker-options="beginDateOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              :label="$l('form_label_shipmentEndDate') || '订舱截止日期'"
              prop="shipmentEndDate"
            >
              <el-date-picker
                v-model="formData.shipmentEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
                :readonly="planningDisabled"
                :picker-options="endDateOptions"
              >
              </el-date-picker
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_operateRemark') || '运营备注'">
              <el-input
                v-model="formData.operateRemark"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                type="textarea"
                :rows="2"
                maxlength="200"
                show-word-limit
                :readonly="planningDisabled"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      v-if="backDialogVisible"
      :visible.sync="backDialogVisible"
      width="30%"
      @close="() => (backDialogVisible = false)"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="confirm()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
import { add, divide } from '@/libs/util.number.js'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  components: { ItemTable },
  props: {
    disabled: { type: Boolean, default: false },
    planningDisabled: { type: Boolean, default: false },
    amzFirstDemandDetailCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      loading: false,
      backDialogVisible: false,
      beginDateOptions: this.shipmentEndDate(),
      endDateOptions: this.shipmentDate(),
    }
  },
  computed: {
    ctnQty() {
      const { qty, inCtnQty } = this.formData
      return divide(qty, inCtnQty)
    },
    firstBox() {
      const { firstQty, inCtnQty } = this.formData
      return divide(firstQty, inCtnQty)
    },
    subQty() {
      const { qty, sampleQty } = this.formData
      return add(qty, sampleQty)
    },

    defaultImageUrl() {
      const { defaultImageUrl } = this.formData
      return defaultImageUrl
        ? this.$osscdn(defaultImageUrl)
        : '/image/static/img/nopic.jpg'
    },

    rules() {
      return {
        firstSaleDay: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        cargoReadyDay: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        shipmentDate: [
          {
            required: !this.planningDisabled,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        shipmentEndDate: [
          {
            required: !this.planningDisabled,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        qty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'change',
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  new Error(
                    this.$l('from_placeholder_qty_not_have_zero') ||
                      '订单产品数量不能为0'
                  )
                )
                return
              }
              if (value < this.formData.firstQty) {
                callback(
                  new Error(
                    this.$l('from_placeholder_cannot_be_less_firstQty') ||
                      '不能小于首批产品上架数量'
                  )
                )
                return
              }
              callback()
            },
          },
        ],
        firstQty: [
          {
            type: 'number',
            required: !this.planningDisabled,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'change',
          },
          {
            validator: (rule, value, callback) => {
              if (!this.planningDisabled && !value) {
                callback(
                  new Error(
                    this.$l('from_placeholder_firstQty_cannot') ||
                      '首批产品上架数量不能为0'
                  )
                )
                return
              }
              if (value > this.formData.qty && !this.planningDisabled) {
                callback(
                  new Error(
                    this.$l('from_placeholder_greater_than_qty') ||
                      '不能大于订单产品数量'
                  )
                )
                return
              }
              callback()
            },
          },
        ],
        ctnQty: [
          {
            validator: (rule, value, callback) => {
              if (!this.ctnQty) {
                callback(
                  new Error(
                    this.$l('from_placeholder_rctnQty_cannot') ||
                      '订单产品箱数不能为0'
                  )
                )
                return
              }
              if (this.ctnQty - parseInt(this.ctnQty)) {
                callback(
                  new Error(
                    this.$l('from_placeholder_ctnQty_not_have_zero') ||
                      '订单产品箱数不能有零头'
                  )
                )
                return
              }
              callback()
            },
          },
        ],
        firstBox: [
          {
            validator: (rule, value, callback) => {
              if (!this.firstBox && !this.planningDisabled) {
                callback(
                  new Error(
                    this.$l('from_placeholder_rirstBoxs_cannot') ||
                      '首批产品上架箱数不能为0'
                  )
                )
                return
              }
              if (
                this.firstBox - parseInt(this.firstBox) &&
                !this.planningDisabled
              ) {
                callback(
                  new Error(
                    this.$l('from_placeholder_firstBoxs_cannot') ||
                      '首批产品上架箱数不能有零头'
                  )
                )
                return
              }
              callback()
            },
          },
        ],
      }
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await this.getData()
      this.loading = false
    },
    async getData() {
      if (!this.amzFirstDemandDetailCode) return
      const res = await this.$api
        .ecomAmzFirstDemandDetailDetailApi({
          amzFirstDemandDetailCode: this.amzFirstDemandDetailCode,
        })
        .catch(() => null)
      const data = res?.body || {}
      this.formData = { ...data }

      this.$refs.itemTable.setData(this.formData.sampleList || [])
      setTimeout(() => {
        this.$refs.form.clearValidate()
      }, 0)
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
      this.$emit('reload')
    },

    async confirm() {
      if (!(await this.formValidate())) return (this.backDialogVisible = false)
      const sampleList = await this.$refs.itemTable.getTableData()
      const params = { ...this.formData, sampleList }
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzFirstDemandDetailEditSaveApi({ ...params })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const detailsResult = await this.$refs.itemTable.validate()
      return formResult && detailsResult
    },
    // 提交时间限制
    shipmentEndDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.formData.shipmentEndDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.formData.shipmentEndDate).getTime() < time.getTime()
          }
        },
      }
    },
    shipmentDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.formData.shipmentDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.formData.shipmentDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
}
.image_div {
  border: 1px solid #ebeef5;
  border-right: none;
}

.sku_main {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  // height: 49px;
  // line-height: 31px;
}

.bg-white {
  background-color: white !important;
}
.side_frame_div {
  height: 25px;
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
  line-height: 25px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  line-height: 25px;
}
.label {
  font-weight: 600;
  color: #101010;
}
</style>
